import {ajax,getRequestUrl,formatData} from "../request";
export default {
  // BD管理 -- BD列表
  bdList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // BD管理 -- 新增/修改bd信息
  bdSave(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdSave'), data, {
      method,
    })
  },
  // BD管理 -- BD工作状态改变
  bdStatusSave(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdStatusSave'), data, {
      method,
    })
  },

  // BD管理 -- BD关系绑定
  bdBind(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdBind'), data, {
      method,
    })
  },

  // BD管理 -- 拉新详情
  bdBindList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdBindList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // BD管理 -- 解除bd绑定
  bdRemoveBind(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdRemoveBind'), data, {
      method,
    })
  },

  // BD管理 -- 审核列表
  bdBindReviewList(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdBindReviewList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
  // BD管理 -- bd审核
  bdBindReview(data, method) {
    return ajax('post', getRequestUrl('/api/Invite/bdBindReview'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/bd.js